import { Component, HostListener, OnInit } from '@angular/core';
import { TranslationModeEnum } from '../../enum/translation-mode-enum';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UpdateMetaService } from '../../service/meta-service.service';
import { RestClientService } from '../../service/rest-client.service';
import { GenerateRouteService } from '../../service/generate-route.service';
import { ResponsiveService } from '../../service/responsive.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})
export class ContactComponent implements OnInit {

  translationModes: any = TranslationModeEnum;
  contactForm: FormGroup;
  formSubmitted: boolean = false;
  contacted: boolean = false;
  isTablet: boolean = this.responsiveService.isTablet() && !this.responsiveService.isPC();
  countries: string[] = [];
  filteredCountries: string[] = [];
  showAutocomplete: boolean = false;
  countryFormControl = new FormControl('');

  constructor(
    private formBuilder: FormBuilder,
    private restClientService: RestClientService,
    private updateMetaService: UpdateMetaService,
    private generateRouteService: GenerateRouteService,
    private responsiveService: ResponsiveService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.updateMetaService.updateMetaTags('Contact');

    this.http.get<any[]>('https://restcountries.com/v3.1/all?fields=name,translations')
      .subscribe(response => {
        this.countries = response.map(c => c.translations.spa?.common || c.name.common);
      });
  }

  /**
   * Inicializa el formulario
   */
  initForm(): void {
    this.contactForm = this.formBuilder.group({
      name: ['', Validators.required],
      mail: ['', [Validators.required, Validators.email]],
      phone: [''],
      country: [''],
      message: ['', Validators.required],
      termsAndConditions: [false, Validators.requiredTrue],
      receiveCommunications: [false]
    });
  }

  /**
   * Envía el formulario
   */
  submitForm(): void {
    if (this.contacted) {
      this.contactForm.reset();
      this.formSubmitted = false;
      this.contacted = false;
    } else {
      this.formSubmitted = true;
      if (this.contactForm.valid) {
        this.restClientService.post('/contact/form', this.contactForm.value).subscribe(
          {
            next: (response) => {
              this.contactForm.reset();
              this.contacted = true;
            },

            error: (err: any) => { },
            complete: () => { }
          }
        );
      }
    }
  }

  /**
   * Obtiene la ruta en función del idioma actual
   * @param routeKey
   * @returns
   */
  getRouterLink(routeKey: any): string {
    return this.generateRouteService.generateRoute(routeKey);
  }

  /**
   * Revisa la resolución al redimensionar la ventana
   * @param event
   */
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isTablet = this.responsiveService.isTablet() && !this.responsiveService.isPC();
  }

  /**
   * Autocompleta el listado de países
   * @param event
   */
  autocompleteCountries(event: any) {
    const input = event.target.value.toLowerCase();
    if (input.length > 1) {
      this.filteredCountries = this.countries.filter(country =>
        country.toLowerCase().startsWith(input)
      );
      this.showAutocomplete = true;
    } else {
      this.showAutocomplete = false;
    }
  }

  /**
   * Selecciona uno de los países del listado
   * @param country
   */
  selectCountry(country: string) {
    this.contactForm.value.country = country;
    this.showAutocomplete = false;
  }
}
